import Home from "@/views/Home.vue";
import Software from "@/views/Software.vue";
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/software',
        name: 'Software',
        component: Software,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/',
        alias: ["/home"],
        name: 'Home',
        component: Home,
    },
    {
        path: '/products',
        name: 'Products',
        component: Home,
    },
    {
        path: '/support',
        name: 'Support',
        component: Home,
    },
    {
        path: '/contacts',
        name: 'Contacts',
        component: Home,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.afterEach((to, from) => {

    if (to.matched.some(record => record.meta.requiresAuth)
        && !router.app.$auth.account) {
        router.app.$auth.login();
    }
})

export default router
